import { Pickup } from 'types/pickup';
import { transformUTCStringToLocalDate } from 'utils/dateUtils';
import * as yup from 'yup';

export const getInitialValues = (pickup: Pickup | null) => ({
  collectionPoint:
    typeof pickup?.collectionPoint !== 'string'
      ? pickup?.collectionPoint?._id
      : '' || '',
  date: pickup?.date ? transformUTCStringToLocalDate(pickup?.date) : '',
  eventName: pickup?.eventName || '',
  notes: pickup?.notes || '',
  isFinalPickup: pickup?.isFinalPickup || false,
});

export const validationSchema = yup.object().shape({
  collectionPoint: yup
    .string()
    .required('Collection Point is a required field'),
  date: yup.date().required('Please enter the Date'),
  eventName: yup.string(),
  isFinalPickup: yup.boolean(),
});
